<template>
    <div class="nong-app">
        <div :class="locale==='zh-CN'?'nong-app-div':'nong-app-div-en'">
            <div class="nong-app-title-box" ref="nongBox" v-show="path=='/main'">
                <img v-if="path=='/main'&&this.$store.getters.getTheme==true" src="../assets/image/home/homeTitleB.png"
                     @click="backHome">
                <img :class="tabShow?'nong-home-icon':''" v-else src="../assets/image/home/homeTitleW.png"
                     @click="backHome">
            </div>
            <div class="nong-app-choice" @mouseenter="enterBox" @mouseleave="upLogoBox">
                <div class="nong-app-title">
                    <img class="nong-home-click" v-if="path=='/main'&&this.$store.getters.getTheme==true"
                         src="../assets/image/home/homeCilckB.png" @mouseenter="enter" @mousedown="choiceHome"
                         @mouseleave="upLogo"/>
                    <img class="nong-home-click" v-else
                         src="../assets/image/home/homeCilckW.png" @mouseenter="enter" @mousedown="choiceHome"
                         @mouseleave="upLogo"/>
                </div>
                <div class="nong-app-title-h5">
                    <img class="nong-home-click" v-if="!tabShow"
                         src="../assets/image/home/homeCilckW.png" @click="tabShow=true"/>
                    <img class="nong-home-click-delete" v-else
                         src="../assets/image/delete.png" @click="tabShow=false"/>
                </div>
                <!--                </router-link>-->
                <div v-if="tabShow" class="nong-home-link-box">
                    <router-link to='/main'>
                        <div id="nong-app-home"
                             :class="{ 'nong-app-choice-div':true,'nong-app-choice-item':choice[0].choice&&this.$store.getters.getTheme==false,
                          'nong-app-choice-itemB':choice[0].choice&&this.$store.getters.getTheme==true,
                         'nong-app-choice-item-un':!choice[0].choice,'nong-app-choice-item-click':choice[0].choice }"
                             @click="choiceHome">
                            <div class="nong-base-choice-main">{{ $t('message.main') }}</div>
                        </div>
                    </router-link>

                    <router-link to='/about'>
                        <div id="nong-app-about"
                             :class="{ 'nong-app-choice-div':true,'nong-app-choice-item':choice[0].choice&&this.$store.getters.getTheme==false,
                          'nong-app-choice-itemB':choice[0].choice&&this.$store.getters.getTheme==true,
                         'nong-app-choice-item-un':!choice[0].choice,'nong-app-choice-item-click':choice[1].choice }"
                             @click="choiceAbout">
                            <div class="nong-base-choice-main">{{ $t('message.about') }}</div>
                        </div>
                    </router-link>

                    <a>
                        <div id="nong-app-works"
                             :class="{ 'nong-app-choice-div':true,'nong-app-choice-item':choice[0].choice&&this.$store.getters.getTheme==false,
                          'nong-app-choice-itemB':choice[0].choice&&this.$store.getters.getTheme==true,
                          'nong-app-choice-item-un':!choice[0].choice,'nong-app-choice-item-click':choice[2].choice }"
                             @click="choiceWorks">
                            <div class="nong-base-choice-main">{{ $t('message.works') }}</div>
                        </div>
                    </a>
                    <div v-if="choice[2].choice" class="nong-app-choice-text">
                        <router-link to='/works?type=1'>
                            <div
                              :class="{ 'nong-app-choice-div':true,'nong-app-choice-item':choice[0].choice&&this.$store.getters.getTheme==false,
                          'nong-app-choice-itemB':choice[0].choice&&this.$store.getters.getTheme==true,
                          'nong-app-choice-item-un':!choice[0].choice,'nong-app-choice-item-click':choice[2].child[0].choice }"
                              @click="choiceBuild">
                                <div class="nong-base-choice-contact">{{ $t('message.build') }}</div>
                            </div>
                        </router-link>
                        <router-link to='/works?type=2'>
                            <div
                              :class="{ 'nong-app-choice-div':true,'nong-app-choice-item':choice[0].choice&&this.$store.getters.getTheme==false,
                          'nong-app-choice-itemB':choice[0].choice&&this.$store.getters.getTheme==true,
                          'nong-app-choice-item-un':!choice[0].choice,'nong-app-choice-item-click':choice[2].child[1].choice }"
                              @click="choiceIndoor">
                                <div class="nong-base-choice-contact">{{ $t('message.indoor') }}</div>
                            </div>
                        </router-link>
                        <router-link to='/works?type=3'>
                            <div
                              :class="{ 'nong-app-choice-div':true,'nong-app-choice-item':choice[0].choice&&this.$store.getters.getTheme==false,
                          'nong-app-choice-itemB':choice[0].choice&&this.$store.getters.getTheme==true,
                          'nong-app-choice-item-un':!choice[0].choice,'nong-app-choice-item-click':choice[2].child[2].choice }"
                              @click="choiceDesign">
                                <div class="nong-base-choice-contact">{{ $t('message.design') }}</div>
                            </div>
                        </router-link>
                        <router-link to='/works?type=4'>
                            <div
                              :class="{ 'nong-app-choice-div':true,'nong-app-choice-item':choice[0].choice&&this.$store.getters.getTheme==false,
                          'nong-app-choice-itemB':choice[0].choice&&this.$store.getters.getTheme==true,
                          'nong-app-choice-item-un':!choice[0].choice,'nong-app-choice-item-click':choice[2].child[3].choice }"
                              @click="choiceVision">
                                <div class="nong-base-choice-contact">{{ $t('message.vision') }}</div>
                            </div>
                        </router-link>
                    </div>
                    <a>
                        <div id="nong-app-report"
                             :class="{ 'nong-app-choice-div':true,'nong-app-choice-item':choice[0].choice&&this.$store.getters.getTheme==false,
                          'nong-app-choice-itemB':choice[0].choice&&this.$store.getters.getTheme==true,
                          'nong-app-choice-item-un':!choice[0].choice,'nong-app-choice-item-click':choice[3].choice}"
                             @click="choiceReport">
                            <div class="nong-base-choice-main">{{ $t('message.report') }}</div>
                        </div>
                    </a>
                    <div v-if="choice[3].choice" class="nong-app-choice-text">
                        <router-link to='/news'>
                            <div id="nong-app-news"
                                 :class="{'nong-app-choice-div':true,'nong-app-choice-item':choice[0].choice&&this.$store.getters.getTheme==false,
                          'nong-app-choice-itemB':choice[0].choice&&this.$store.getters.getTheme==true,
                          'nong-app-choice-item-un':!choice[0].choice,'nong-app-choice-item-click':choice[3].child[0].choice }"
                                 @click="choiceNews">
                                <div class="nong-base-choice-contact">{{ $t('message.news') }}</div>
                            </div>
                        </router-link>
                        <router-link to='/publications'>
                            <div id="nong-app-publications"
                                 :class="{ 'nong-app-choice-div':true,'nong-app-choice-item':choice[0].choice,'nong-app-choice-item-un':!choice[0].choice,'nong-app-choice-item-click':choice[3].child[1].choice }"
                                 @click="choicePublication">
                                <div class="nong-base-choice-contact">{{ $t('message.publication') }}</div>
                            </div>
                        </router-link>
                    </div>
                    <router-link to='/contact'>
                        <div id="nong-app-contact"
                             :class="{ 'nong-app-choice-div':true,'nong-app-choice-item':choice[0].choice&&this.$store.getters.getTheme==false,
                          'nong-app-choice-itemB':choice[0].choice&&this.$store.getters.getTheme==true,
                          'nong-app-choice-item-un':!choice[0].choice,'nong-app-choice-item-click':choice[4].choice }"
                             @click="choiceContact">
                            <div class="nong-base-choice-main">{{ $t('message.contact') }}</div>
                        </div>
                    </router-link>
                    <div class="nong-app-language">
                        <div class="nong-base-choice-main">
                    <span :class="{'nong-main-l':true,'nong-main-zh':true,'nong-main-unclick':locale!='zh-CN'}"
                          @click="clickCN">中</span><span
                          class="nong-app-divide">|</span><span
                          :class="{'nong-main-l':true, 'nong-main-en':true,'nong-main-unclick':locale=='zh-CN'}"
                          @click="clickEN">EN</span>
                        </div>
                    </div>
                </div>
            </div>
            <router-view v-if="isRouterAlive"></router-view>
        </div>
        <div class="nong-app-foot">
            <div style="z-index: 999">技术支持：上海东优信息技术有限公司</div>
            <el-link type="info" @click="open">沪ICP备17014914号-1</el-link>
        </div>
    </div>
</template>

<script>
export default {
    name: "Base",
    data: () => ({
        isIosShow: false,
        screenWidth: '',
        locale: 'zh-CN',
        choice: [],
        logoChange: false,
        path: '/main',
        tabShow: false,
        isRouterAlive: true,
        tabBoxShow: false,
        choiceData: [
            {name: 'cHome', choice: false},
            {name: 'cAbout', choice: false},
            {
                name: 'cWorks', choice: false,
                child: [{name: 'cBuild', choice: false}, {name: 'cIndoor', choice: false}, {
                    name: 'cDesign',
                    choice: false
                }, {name: 'cVision', choice: false}]
            },
            {
                name: 'cReport', choice: false,
                child: [{name: 'cNews', choice: false}, {name: 'cPublication', choice: false}]
            },
            {name: 'cContact', choice: false}
        ]
    }),
    mounted() {
        let u = navigator.userAgent;
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isiOS) {
            this.isIosShow = true
            this.$refs.nongBox.style.height = document.body.clientHeight + 'px'
        } else {
            this.isIosShow = false
        }

    },
    watch: {
        $route(to) {
            // window.console.log(this.$route.query)
            this.path = to.path
            this.$store.commit("setRouter", to.path);
            if (to.path == "/" || to.path == "/main") {
                this.choiceHome()
            } else if (to.path == "/about") {
                this.choiceAbout()
            } else if (to.path == "/works") {
                if (this.$route.query.type == "build") {
                    this.choiceBuild()
                } else if (this.$route.query.type == "design") {
                    this.choiceDesign()
                } else if (this.$route.query.type == "indoor") {
                    this.choiceIndoor()
                } else if (this.$route.query.type == "vision") {
                    this.choiceVision()
                }
            } else if (to.path == "/news") {
                this.choiceNews()
            } else if (to.path == "/publications") {
                this.choicePublication()
            } else if (to.path == "/contact") {
                this.choiceContact()
            }
        }
    },
    created() {
        // if (this.$store.getters.getChoice.length > 0) {
        //   // eslint-disable-next-line no-console
        this.$nextTick(() => {
            this.locale = localStorage.getItem('locale')
            // window.console.log(this.locale)
        })

        this.path = this.$route.path
        // window.console.log(this.$route.path)
        if (this.$store.getters.getChoice.length != 0) {
            this.choice = this.$store.getters.getChoice
        } else {
            this.choice = [
                {name: 'cHome', choice: true},
                {name: 'cAbout', choice: false},
                {
                    name: 'cWorks', choice: false,
                    child: [{name: 'cBuild', choice: false}, {name: 'cIndoor', choice: false}, {
                        name: 'cDesign',
                        choice: false
                    }, {name: 'cVision', choice: false}]
                },
                {
                    name: 'cReport', choice: false,
                    child: [{name: 'cNews', choice: false}, {name: 'cPublication', choice: false}]
                },
                {name: 'cContact', choice: false}
            ]
        }
    },

    methods: {
        clickTab: function () {
            this.tabShow = !this.tabShow
        },

        backHome: function () {
            this.choice = JSON.parse(JSON.stringify(this.choiceData))
            for (let i = 0; i < this.choice.length; i++) {
                if (this.choice[i].name == 'cHome') {
                    this.choice[i].choice = true
                } else {
                    this.choice[i].choice = false
                }
            }

            if (this.$route.path == '/main') {
                return
            } else {
                this.$router.push('/main')
            }
            this.$store.commit("setChoice", this.choice);
        },

        choiceHome: function () {
            // 点击首页的图标
            // eslint-disable-next-line no-console
            // console.log("url--info", this.$route.path);
            this.choice = JSON.parse(JSON.stringify(this.choiceData))
            for (let i = 0; i < this.choice.length; i++) {
                if (this.choice[i].name == 'cHome') {
                    this.choice[i].choice = true
                } else {
                    this.choice[i].choice = false
                }
            }

            if (this.$route.path == '/main') {
                return
            } else {
                this.$router.push('/main')
            }

            this.$store.commit("setChoice", this.choice);
            if (this.$store.getters.getClientWidth < 960) {
                this.tabShow = false
            }
        }
        ,

        choiceAbout: function () {
            // 点击关于
            this.choice = JSON.parse(JSON.stringify(this.choiceData))
            for (let i = 0; i < this.choice.length; i++) {
                if (this.choice[i].name == 'cAbout') {
                    this.choice[i].choice = true
                } else {
                    this.choice[i].choice = false
                }
            }
            this.$store.commit("setChoice", this.choice);
            // window.console.log(this.$store.getters.getChoice)
            this.$store.commit("setChoice", this.choice);
            if (this.$store.getters.getClientWidth < 960) {
                this.tabShow = false
            }
        }
        ,

        choiceWorks: function () {
            // 点击作品
            for (let i = 0; i < this.choice.length; i++) {
                if (this.choice[i].name == 'cWorks') {
                    this.choice[i].choice = true
                } else {
                    this.choice[i].choice = false
                }
            }
            this.$store.commit("setChoice", this.choice);
        }
        ,

        choiceBuild: function () {
            // 点击建筑
            for (let i = 0; i < this.choice.length; i++) {
                if (this.choice[i].name == 'cWorks') {
                    for (let y = 0; y < this.choice[i].child.length; y++) {
                        if (this.choice[i].child[y].name == 'cBuild') {
                            this.choice[i].child[y].choice = true
                        } else {
                            this.choice[i].child[y].choice = false
                        }
                    }
                }
            }
            this.$store.commit("setChoice", this.choice);
            this.$store.commit("setChoice", this.choice);
            if (this.$store.getters.getClientWidth < 960) {
                this.tabShow = false
            }
        }
        ,

        choiceIndoor: function () {
            // 点击室内
            for (let i = 0; i < this.choice.length; i++) {
                if (this.choice[i].name == 'cWorks') {
                    for (let y = 0; y < this.choice[i].child.length; y++) {
                        if (this.choice[i].child[y].name == 'cIndoor') {
                            this.choice[i].child[y].choice = true
                        } else {
                            this.choice[i].child[y].choice = false
                        }
                    }
                }
            }
            this.$store.commit("setChoice", this.choice);
            this.$store.commit("setChoice", this.choice);
            if (this.$store.getters.getClientWidth < 960) {
                this.tabShow = false
            }
        }
        ,

        choiceDesign: function () {
            // 点击设计
            for (let i = 0; i < this.choice.length; i++) {
                if (this.choice[i].name == 'cWorks') {
                    for (let y = 0; y < this.choice[i].child.length; y++) {
                        if (this.choice[i].child[y].name == 'cDesign') {
                            this.choice[i].child[y].choice = true
                        } else {
                            this.choice[i].child[y].choice = false
                        }
                    }
                }
            }
            this.$store.commit("setChoice", this.choice);
            this.$store.commit("setChoice", this.choice);
            if (this.$store.getters.getClientWidth < 960) {
                this.tabShow = false
            }
        }
        ,

        choiceVision: function () {
            // 点击视觉
            for (let i = 0; i < this.choice.length; i++) {
                if (this.choice[i].name == 'cWorks') {
                    for (let y = 0; y < this.choice[i].child.length; y++) {
                        if (this.choice[i].child[y].name == 'cVision') {
                            this.choice[i].child[y].choice = true
                        } else {
                            this.choice[i].child[y].choice = false
                        }
                    }
                }
            }
            this.$store.commit("setChoice", this.choice);
            this.$store.commit("setChoice", this.choice);
            if (this.$store.getters.getClientWidth < 960) {
                this.tabShow = false
            }
        }
        ,

        choiceReport: function () {
            // 点击报道
            for (let i = 0; i < this.choice.length; i++) {
                if (this.choice[i].name == 'cReport') {
                    this.choice[i].choice = true
                } else {
                    this.choice[i].choice = false
                }
            }
            this.$store.commit("setChoice", this.choice);
        }
        ,

        choiceNews: function () {
            // 点击新闻

            for (let i = 0; i < this.choice.length; i++) {
                if (this.choice[i].name == 'cReport') {
                    for (let y = 0; y < this.choice[i].child.length; y++) {
                        if (this.choice[i].child[y].name == 'cNews') {
                            this.choice[i].child[y].choice = true
                        } else {
                            this.choice[i].child[y].choice = false
                        }
                    }
                }
            }
            this.$store.commit("setChoice", this.choice);
            this.$store.commit("setChoice", this.choice);
            if (this.$store.getters.getClientWidth < 960) {
                this.tabShow = false
            }
        }
        ,

        choicePublication: function () {
            // 点击刊物
            for (let i = 0; i < this.choice.length; i++) {
                if (this.choice[i].name == 'cReport') {
                    for (let y = 0; y < this.choice[i].child.length; y++) {
                        if (this.choice[i].child[y].name == 'cPublication') {
                            this.choice[i].child[y].choice = true
                        } else {
                            this.choice[i].child[y].choice = false
                        }
                    }
                }
            }
            this.$store.commit("setChoice", this.choice);
            this.$store.commit("setChoice", this.choice);
            if (this.$store.getters.getClientWidth < 960) {
                this.tabShow = false
            }
        }
        ,

        choiceContact: function () {
            // 点击联系
            this.choice = JSON.parse(JSON.stringify(this.choiceData))
            for (let i = 0; i < this.choice.length; i++) {
                if (this.choice[i].name == 'cContact') {
                    this.choice[i].choice = true
                } else {
                    this.choice[i].choice = false
                }
            }
            this.$store.commit("setChoice", this.choice);

        },

        enterBox: function () {
            this.tabBoxShow = true
        },

        enter: function () {
            // this.logoChange = true
            // this.tabShow = !this.tabShow
            this.tabShow = true
        },

        upLogoBox: function () {
            this.tabBoxShow = false
            this.tabShow = false
        },
        upLogo: function () {
            if (this.tabBoxShow) {
                this.tabShow = true
            } else {
                this.tabShow = false
            }
        },

        clickCN: function () {
            if (localStorage.getItem('locale') != 'zh-CN') {

                this.$i18n.locale = 'zh-CN'
                localStorage.setItem('locale', 'zh-CN');

                this.isRouterAlive = false
                this.$nextTick(function () {
                    this.isRouterAlive = true
                    this.locale = localStorage.getItem('locale')
                    // window.console.log(this.locale)
                })
            }

        },

        clickEN: function () {
            if (localStorage.getItem('locale') != 'en-US') {
                this.$i18n.locale = 'en-US'
                localStorage.setItem('locale', 'en-US');
                // window.console.log(localStorage.getItem('locale'))
                this.isRouterAlive = false
                this.$nextTick(function () {
                    this.isRouterAlive = true
                    this.locale = localStorage.getItem('locale')
                    // window.console.log(this.locale)
                })
            }
        },

        open() {
            window.open('http://beian.miit.gov.cn/')
        }
    }
}
</script>

<style scoped>
@media screen and (min-width: 960px) {
    .nong-app{
        width: 100%;
        height: 100%;
        background-color: #000000;
    }

    .nong-app-foot {
        display: flex;
        flex-direction: row;
        width: 100%;
        height: 20px;
        background-color: #000000;
        font-family: sy-HanSansCN-Noraml;
        color: rgba(255,255,255,.5);
        font-size: 10px;
        justify-content: center;
        align-items: center;
    }

    /deep/.nong-app-foot .el-link--inner {
        font-family: sy-HanSansCN-Noraml;
        color: rgba(255,255,255,.5);
        font-size: 10px;
    }

    .nong-app-div {
        width: 100%;
        height: calc(100% - 20px);
        background-color: #000000;
        font-family: sy-HanSansCN-Noraml;
    }

    .nong-app-div-en {
        width: 100%;
        height: calc(100% - 20px);
        background-color: #000000;
        font-family: Montserrat;
    }

    .nong-app-choice {
        position: absolute;
        top: 20px;
        left: 20px;
        color: white;
        font-size: 10px;
        z-index: 2;
        /*line-height: 15px;*/
    }

    .nong-app-divide {
        margin: 0 5px;
    }

    .nong-app-title {
        width: 100%;
        height: 40px;
        position: relative;
        cursor: pointer;
    }

    .nong-app-title-h5 {
        display: none;
    }

    .nong-home-click {
        width: 30px;
        height: 30px;
        position: absolute;
        left: -5px;
    }

    .nong-app-title-box {
        width: 100%;
        height: 30px;
        /*background-color: white;*/
        position: absolute;
        top: 20px;
        z-index: 2;
        display: flex;
        justify-content: flex-end;
        padding: 0 40px;
        box-sizing: border-box;
    }

    .nong-app-title-box img {
        width: 160px;
        height: 26px;
    }

    .nong-logo {
        width: 50px;
        margin-bottom: 20px;
    }

    .router-link-active {
        text-decoration: none;
    }

    a {
        text-decoration: none;
    }

    .nong-app-choice-item {
        color: white;
        margin-bottom: 3px;
        font-weight: 500;
    }

    .nong-app-choice-itemB {
        color: #000000;
        margin-bottom: 3px;
        font-weight: 500;
    }

    .nong-app-choice-item-click {
        color: white !important;
        margin-bottom: 3px;
    }

    .nong-app-choice-item-un {
        color: #535353;
        margin-bottom: 3px;
        font-weight: 500;
    }

    .v-application {
        height: 100%;
        width: 100%;
    }

    .nong-main-l {
        cursor: pointer;
    }

    .nong-app-choice-text {
        font-size: 8px !important;
        font-weight: 500;
        line-height: 13px;
        margin-bottom: 12px;
    }

    .nong-main-zh {
        font-family: sy-HanSansCN-Noraml;
    }

    .nong-main-en {
        font-family: Montserrat;
    }

    .nong-main-unclick {
        color: #535353;
    }

    .nong-app-choice-div:hover {
        /*cursor: pointer;*/
        -webkit-transform: scale(1.1);
        color: white;
    }

}

@media screen and (max-width: 960px) {

  .nong-app{
    width: 100%;
    height: calc(100% - 20px);
    background-color: #000000;
  }

  .nong-app-foot {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 20px;
    background-color: #000000;
    font-family: sy-HanSansCN-Noraml;
    color: rgba(255,255,255,.5);
    font-size: 10px;
    justify-content: center;
    align-items: center;
  }

  /deep/.nong-app-foot .el-link--inner {
    font-family: sy-HanSansCN-Noraml;
    color: rgba(255,255,255,.5);
    font-size: 10px;
  }

    .nong-app-div {
        width: 100%;
        height: 100%;
        background-color: #000000;
        font-family: sy-HanSansCN-Noraml;
        overflow-y: auto;
    }

    .nong-app-div-en {
        width: 100%;
        height: 100%;
        background-color: #000000;
        font-family: Montserrat;
        overflow-y: auto;
    }

    .nong-app-choice {
        position: absolute;
        top: 20px;
        color: white;
        width: 100%;
        font-size: 16px;
        z-index: 2;
        /*line-height: 15px;*/
    }

    .nong-app-divide {
        margin: 0 5px;
    }

    .nong-app-title {
        display: none;
    }

    .nong-app-title-h5 {
        width: 100%;
        height: 30px;
        position: relative;
    }

    .nong-home-click {
        width: 35px;
        height: 35px;
        position: absolute;
        left: 20px;
    }

    .nong-home-click-delete {
        width: 23px;
        height: 23px;
        position: absolute;
        left: 20px;
    }

    .nong-bottom .nong-home-icon {
        position: absolute;
        right: 20px;
        bottom: 80px;
    }

    .nong-home-icon {
        position: absolute;
        right: 20px;
        bottom: 20px;
    }

    .nong-app-title-box {
        width: 100%;
        height: 100%;
        /*background-color: white;*/
        position: absolute;
        z-index: 2;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .nong-app-title-box img {
        width: 190px;
        height: 35px;
    }

    .nong-logo {
        width: 50px;
        margin-bottom: 20px;
    }

    .router-link-active {
        text-decoration: none;
    }

    a {
        text-decoration: none;
    }

    .nong-app-choice-item {
        color: white;
        /*margin-bottom: 3px;*/
        font-weight: 500;
        height: 40px;
    }

    .nong-app-choice-itemB {
        color: #000000;
        margin-bottom: 3px;
        font-weight: 500;
    }

    .nong-app-choice-item-click {
        color: white !important;
        /*margin-bottom: 3px;*/
    }

    .nong-app-choice-item-un {
        color: #535353;
        /*margin-bottom: 3px;*/
        font-weight: 500;
        display: flex;
        align-items: center;
        background: rgba(0, 0, 0, 0.8);
    }

    .v-application {
        height: 100%;
        width: 100%;
    }

    .nong-main-l {
        cursor: pointer;
    }

    .nong-app-choice-text {
        font-weight: 500;
    }

    .nong-main-zh {
        font-family: sy-HanSansCN-Noraml;
    }

    .nong-main-en {
        font-family: Montserrat;
    }

    .nong-main-unclick {
        color: #535353;
    }

    .nong-app-choice-div {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        background: rgba(0, 0, 0, 0.8);
        border-bottom: 1px solid rgba(112, 112, 112, 1);
    }

    .nong-base-choice-main {
        width: 100%;
        padding-left: 20px;
    }

    .nong-base-choice-contact {
        padding-left: 56px;
    }

    .nong-app-language {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        background: rgba(0, 0, 0, 0.8);
    }

    .nong-bottom {
        padding-bottom: 60px;
        box-sizing: border-box;
    }

}
</style>
